import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { SystemProps } from '@sternum/styled-system';

import { MenuContent, MenuSectionStyled, MenuSectionTitle } from './MenuSection.styles';

export interface MenuSectionProps extends Omit<ComponentPropsWithoutRef<'div'>, 'title'> {
  title?: ReactNode;
  menuContentProps?: ComponentPropsWithoutRef<'div'> & SystemProps;
  useTitlePlaceholder?: boolean;
}

export function MenuSection({ title, children, menuContentProps, useTitlePlaceholder, ...props }: MenuSectionProps) {
  return (
    <MenuSectionStyled
      role="presentation"
      aria-label="menu section"
      data-has-title-placeholder={!title && useTitlePlaceholder}
      {...props}
    >
      {title && <MenuSectionTitle>{title}</MenuSectionTitle>}
      <MenuContent {...menuContentProps}>{children}</MenuContent>
    </MenuSectionStyled>
  );
}
